export const MAX_UPLOAD_BYTES = 25_000_000;
export const ALLOWED_CONTENT_TYPES = Object.freeze([
  'application/pdf',
  'image/jpeg',
  'image/png',
]);

export function validateDocumentFile(file) {
  if (!file) return 'Choose a PDF, JPEG or PNG file.';
  if (!ALLOWED_CONTENT_TYPES.includes(file.type)) {
    return 'Only PDF, JPEG and PNG files are supported.';
  }
  if (file.size <= 0) return 'The selected file is empty.';
  if (file.size > MAX_UPLOAD_BYTES) return 'The selected file is larger than 25 MB.';
  return null;
}

// One object to storage, on the contract the API issued: a PUT to a signed Cloud Storage URL,
// a POST to the emulator's media upload. The method is the API's to say, as the headers are.
export async function putDocument(file, uploadUrl, requiredHeaders, method = 'PUT') {
  const response = await fetch(uploadUrl, {
    method,
    headers: requiredHeaders,
    body: file,
  });

  if (!response.ok) {
    throw new Error(`Storage upload failed: ${response.status} ${response.statusText}`);
  }
}
